/* v.015 For use with custom lenght input on products pages */
/* v.015 adds lengthOptions from data attribute update findLengthInOptions(), and `length` string handling in clickLengthVariantOption(), parse input attributes */
/* v.031 fix - add check for customLengthTabs existence before running tab change event listener code */
/*(function() {})(); */

/*!Important assumes a variants option1 property is `length` with format `XXXcm`*/
/*!Important due to the clickBehavior implementation a variant change event can causesa feedback loop with custom-length input change event */

/* enable input with javascript once user opens the custom-length tab */
  /* selector samples: tab-link.tab-link-1 , tab-link.tab-link-1.current,  tab-content.tab-content-1 , tab-content.tab-content-1.current */
const customLengthTabs = document.querySelector('#customLengthTabs [data-tabs-holder]');
if ( customLengthTabs ) {
  document.querySelector('#customLengthTabs [data-tabs-holder]').addEventListener('theme:tab:change', (event) => {
    if (customLengthInput.dataset.firstUse && customLengthInput.dataset.firstUse == "true") {
      customLengthInput.dataset.firstUse = "false"
    }
    if (DEBUGCUSTOMLENGTHEVENTS) {debugger}
    enableCustomLength(event, true);
    clickLengthVariantOption( findLengthInOptions(customLengthInput.value, lengthOptions) );
    //clickLengthVariantOption( roundUpTo(customLengthInput.value,customLengthInputIncrement) );
  });
}

/* disable custom-length once user selects a new variant LENGTH option but NOT for other options */
document.addEventListener('theme:variant:change', (event) => {
  if (DEBUGCUSTOMLENGTHEVENTS) {debugger}
  /* the theme refreshes button state on variant change and can re-enable a button
     we greyed out; re-assert after its handler has run */
  if (customLengthError && customLengthError.style.display !== 'none') {
    setTimeout(function () { showCustomLengthError(true); }, 0);
  }
  /* exit if variant id hasn't changed */
  if (customLengthInput.dataset.selectedVariantId == event.detail.variant.id) {
    return
  }
  if (customLengthInput.dataset.selectedVariantId != event.detail.variant.id) {
    customLengthInput.dataset.selectedVariantId = event.detail.variant.id;
    customLengthInput.dataset.selectedVariantLength = event.detail.variant.option1;
  }
  /* exit if custom-length tab is active , variant:change can be from the `glider type` option etc */
  if (customLengthTabs && customLengthTabs.querySelector('.tab-content-1.current') ) {
    return
  }
  /* is selected variant length different from custom-length */
  if (event.detail.variant.option1 != customLengthInput.value+"cm") {
    // enableCustomLength(null, false);
  }

  if (customLengthInput.dataset.selectedVariantLength != event.detail.variant.option1 ) {

  }
});

function enableCustomLength(event,enable) {
  if (event==null && enable) {
    customLengthInput.disabled = false;
    /* customLengthInput.removeAttribute('data-use-custom-length'); */
    currentVariantValue = getVariantLengthCurrentOption();
    if (currentVariantValue > customLengthInput.value ) {

    }
    customLengthInput.value = getVariantLengthCurrentOption();
    return
  }
  if (event && event.detail.tab.classList.contains('tab-content-1') && enable) {
    customLengthInput.disabled = false;
  } else {
    /* future UX: somehow highlight that custom-length has become disabled after selecting a variant? */
    customLengthInput.disabled = true;
  }
}

/* config */
  var DEBUGCUSTOMLENGTHINPUT = false;
  var DEBUGCUSTOMLENGTHEVENTS = false;
  var customLengthInput = document.getElementById('CustomLengthInput');
  if (customLengthInput) {
    var lengthOptions = customLengthInput.dataset.valueLengthOptions.split(',');
  }

  var customLengthInputs = document.querySelectorAll('[data-quantity-input-custom-length]');
    /* for testing if multiple customLengthInputs on page from dev outputs, get all the inputs but ignore the main input */
    customLengthInputs = Array.from(customLengthInputs).filter( (input )=>{ return input != customLengthInput } );
  var customLengthInputMin = parseInt(customLengthInput.min);
  var customLengthInputMax = parseInt(customLengthInput.max);
  if (customLengthInput.getAttribute("data-value-increment") !== null) {
    var customLengthInputIncrement = parseInt(customLengthInput.dataset.valueIncrement);
  }
  var customLengthValueDefault = parseInt(customLengthInput.min);
  /* var setCustomLengthInputValueToRoundedValue = false; */

  /*var variantDropDown = document.getElementById('product-form-template--14939837104231__main-6878394515559-select-length'); */
  var variantDropDown = document.querySelector('[id^=product-form-template--][id$=select-length]');

// future init to set length value to currently selected variant on load?
// document.addEventListener('load', (e) => { initCustomLength(e) } );

customLengthInput && customLengthInput.addEventListener('change',(e) => { mapCustomLengthToVariantLength(e) } );
customLengthInputs && customLengthInputs.forEach( (input) =>  input.addEventListener('change',(e) => { mapCustomLengthToVariantLength(e) }) );
// customLengthInput.addEventListener('change',mapCustomLengthToVariantLength(event) );

/*
  //UNIMPLEMENTED - WARNING , creates a feedback loop so custom value always gets set to a variant option value
  // this should instead probably be when a variant is selected AFTER a custom lenght is entered a checkbox disables/enables the customlength-input
  document.addEventListener('theme:variant:change', (event) => { updateCustomLength(event) } )
  function updateCustomLength(event) {
    if (DEBUGCUSTOMLENGTHINPUT) {debugger}
    if (event.type == 'theme:variant:change') {
      customLengthInput.value = parseInt( event.detail.variant.option1.replace('cm','') );
      return
    }
    // mapCustomLengthToVariantLength(event, emitEvent = false);
  }
*/
function mapCustomLengthToVariantLength(event, emitEvent) {
    if (DEBUGCUSTOMLENGTHINPUT) {debugger}
    if (!event) { return }

    var customLengthValue = parseInt(event.target.value);
    // future: rename cutLengthValue to something less confusing vs customLengthValue
    var cutLengthValue = customLengthValueDefault;

    /* over the maximum available length: show the validation message and do NOT remap,
       otherwise the cart keeps the previously selected (shorter, cheaper) variant */
    if (customLengthValue > customLengthInputMax) {
      showCustomLengthError(true);
      logForCustomLengthInput('customLength value over maximum');
      return
    }
    showCustomLengthError(false);

    /* clamp the inputs value between it's minium and maximum value */
    if (customLengthValue < customLengthInputMin) {
      customLengthValue = customLengthInputMin;
      event.target.value = customLengthValue;
      logForCustomLengthInput('customLength value went out of bounds');
    }

    if (customLengthValue >= customLengthInputMin && customLengthValue <= customLengthInputMax) {
      // if divisible by customLengthInputIncrement (25) use that value
      if (customLengthValue % customLengthInputIncrement == 0 ) {
        logForCustomLengthInput('cutLengthValue: '+ cutLengthValue);
        clickLengthVariantOption(customLengthValue);
        if (DEBUGCUSTOMLENGTHINPUT) {debugger}
        customLengthInput.dataset.selectedVariantLength = customLengthValue;
        return
      }

      cutLengthValue = findLengthInOptions(customLengthValue, lengthOptions);
      //cutLengthValue = roundUpTo(customLengthValue,customLengthInputIncrement);
      logForCustomLengthInput('cutLengthValue: '+ cutLengthValue);
      customLengthInput.dataset.selectedVariantLength = cutLengthValue;
      clickLengthVariantOption(cutLengthValue);
    }
}
function logForCustomLengthInput (message) {
  if (DEBUGCUSTOMLENGTHINPUT) { console.log(message); }
}

/* validation message rendered by product-variant-options-selector-by-range.liquid */
var customLengthError = document.getElementById('CustomLengthInputError');

function customLengthAddButtons() {
  var buttons = [];
  if (customLengthForm) {
    buttons = Array.from(customLengthForm.elements).filter(function (el) {
      return el.matches('[data-add-to-cart], [type="submit"]');
    });
  }
  if (!buttons.length) {
    var scope = customLengthInput.closest('[data-product]') || document;
    buttons = Array.from(scope.querySelectorAll('[data-add-to-cart]'));
  }
  return buttons;
}

function showCustomLengthError(show) {
  if (!customLengthError) { return }
  customLengthError.style.display = show ? 'block' : 'none';
  customLengthInput.setAttribute('aria-invalid', show ? 'true' : 'false');
  /* grey out add-to-cart while invalid; only touch buttons WE disabled so a
     sold-out disable from the theme is never undone from here */
  customLengthAddButtons().forEach(function (button) {
    if (show && !button.disabled) {
      button.disabled = true;
      button.setAttribute('data-custom-length-disabled', '');
    }
    if (!show && button.hasAttribute('data-custom-length-disabled')) {
      button.disabled = false;
      button.removeAttribute('data-custom-length-disabled');
    }
  });
}

/* block add-to-cart while the entered length is invalid (capture phase, ahead of the theme's own submit handling) */
var customLengthForm = customLengthInput ? document.getElementById(customLengthInput.getAttribute('form')) : null;
if (customLengthForm) {
  customLengthForm.addEventListener('submit', function(event) {
    if (customLengthError && customLengthError.style.display !== 'none') {
      event.preventDefault();
      event.stopPropagation();
      customLengthInput.focus();
    }
  }, true);
}


function roundUpTo(x,y){ return Math.ceil(x / y) * y }

function roundTo(x,y){ return Math.round(x / y) * y }

function clickLengthVariantOption(length) {
  if ( length == null ) { return } /* findLengthInOptions returns undefined when no option is long enough */
  if ( length > customLengthInputMax ) { return }
  if (DEBUGCUSTOMLENGTHINPUT) {debugger}
  // variantDropDown.querySelector('li a[data-value="150cm"]');
  length = length.replace('cm', '');
  variantDropDownOptionElement = variantDropDown.querySelector('li a[data-value="'+length+'cm"]');
  // TODO if already selected value fail condition or return early
  if (variantDropDownOptionElement) {
    variantDropDownOptionElement.click();
  }
}

function findLengthInOptions(length /*Number*/ , options /*Array of Numbers*/ ) {
  if (DEBUGCUSTOMLENGTHINPUT) { debugger; }
  /* length options are strings formatted as XXXcm, i.e. 125cm 240cm ,etc */
  var found = options.find(option => parseInt(option.replace('cm', '')) >= length);
  return found
}

function getVariantLengthCurrentOption(variantSelect = variantDropDown) {
  if (DEBUGCUSTOMLENGTHINPUT) {debugger}
  /* selected option has attribute: aria-current="true" */
  var optionsCurrentValue = variantDropDown.querySelector('li a[data-popout-option][aria-current="true"]');
  //var optionsCurrentValue = [...options].filter( option => option.hasAttribute('aria-current') );
  return optionsCurrentValue.dataset.value.replace('cm','')
}
function getVariantLengthOptions (variantSelect = variantDropDown) {
  //var variantDropDown = document.querySelector('[id^=product-form-template--][id$=select-length]');
  var options = variantDropDown.querySelectorAll('li a[data-popout-option]');
  var optionValues = [...options].map( option => parseInt(option.dataset.value.replace('cm','') ) );
  return optionValues
}